import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/trophy.svg'


const _withScopeId = n => (_pushScopeId("data-v-4a857646"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rank-info" }
const _hoisted_2 = { class: "rank" }
const _hoisted_3 = { class: "number" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "data-v-5053a68c": "",
  src: _imports_0,
  alt: "trophy"
}, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "ordinal"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "ordinal" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "last30" }, "Last 30 Days", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_12 = { class: "top-performers" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "top-performers-heading" }, "Top Performers", -1))
const _hoisted_14 = { class: "results" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScorecardRankRow = _resolveComponent("ScorecardRankRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.rankValues.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _hoisted_5,
                _createTextVNode("  " + _toDisplayString(_ctx.rankValues.join(', ')), 1),
                (_ctx.rankValues.length === 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getOrdinalRank(_ctx.rankValues[0])), 1))
                  : _createCommentVNode("", true),
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, " in " + _toDisplayString(_ctx.scorecard.rankFieldLabel), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, " - "))
        ]),
        _hoisted_10
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scorecardRanks, (rank, index) => {
          return (_openBlock(), _createBlock(_component_ScorecardRankRow, {
            key: index,
            rank: rank,
            "rank-num": index + 1,
            active: _ctx.scorecard.names.indexOf(rank.name) >= 0,
            "min-value": _ctx.minValue,
            "max-value": _ctx.maxValue,
            "company-nps": Number(_ctx.companyNps),
            "is-last": index + 1 === _ctx.scorecardRanks.length,
            avatar: _ctx.getAvatar(rank),
            "is-five-score-question-type": 
                        _ctx.scorecard.isFiveScoreQuestionType
                    
          }, null, 8, ["rank", "rank-num", "active", "min-value", "max-value", "company-nps", "is-last", "avatar", "is-five-score-question-type"]))
        }), 128))
      ])
    ]),
    (_ctx.scorecard && _ctx.scorecard.ranks.length > 3)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "show-more uk-text-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded))
        }, [
          (_ctx.expanded)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Collapse"))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, "Show more"))
        ]))
      : _createCommentVNode("", true)
  ]))
}